export enum LanguageType {
    Core = 0,
    NonCore = 1,
    Unsupported = 2,
}

export default LanguageType;
